import { RESET_PASSWORD_KEY, STEPPER_FORM_DATA_KEY } from '../constants/stepperFormDataKey'

// eslint-disable-next-line
export const setStepperFormData = (formData: any): void => {
  sessionStorage.setItem(STEPPER_FORM_DATA_KEY, JSON.stringify(formData))
}
// eslint-disable-next-line
export const setUserForResetPassword = (userData: any): void => {
  sessionStorage.setItem(RESET_PASSWORD_KEY, JSON.stringify(userData))
}
